import styled from 'styled-components';

import logos_bg_brown from '../../assets/images/footer-brown-bg.png';
import logos_bg_orange from '../../assets/images/footer-orange-bg.png';
import logos_bg_pink from '../../assets/images/footer-pink-bg.png';
import logos_bg_purple from '../../assets/images/footer-purple-bg.png';

interface IScFooterWrapper {
	color?: string;
}

export const ScFooterWrapper = styled.div<IScFooterWrapper>`
	display: flex;
	flex-direction: column;
	gap: 6px;
	border-radius: 15px;
	overflow: hidden;
	a {
		text-decoration: none;
	}
	background: ${({ theme, color }) => color || theme.colors.blueberry};
	@media (min-width: 768px) {
		border-radius: 30px;
	}
	.no-underline {
		text-decoration: none !important;
		cursor: default !important;
	}
	.no-underline.clickable-footer-link {
		cursor: pointer !important;
	}
	.no-underline.clickable-footer-link:hover {
		text-decoration: underline !important;
	}
`;

export const ScFooterTop = styled.div`
	padding: 55px 60px;
	flex-direction: column;
	display: flex;
	gap: 16px;
	@media (max-width: 1440px) {
		padding: 48px 48px 0 48px;
	}
`;

export const ScFooterContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 50px;
`;

export const ScFooterRowWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ScFooterRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const ScFooterLinksWrapper = styled.div`
	display: grid;
	gap: 40px;
	grid-template-columns: repeat(6, 1fr);
	width: 100%;
	@media (max-width: 1550px) {
		gap: 30px;
	}
	@media (max-width: 1300px) {
		gap: 10px;
	}
`;

export const ScFooterLinksGroup = styled.div`
	display: flex;
	flex-direction: column;
	display: flex;
`;

export const ScFooterLogos = styled.div<IScFooterWrapper>`
	height: 160px;
	width: 100%;
	background-image: ${({ theme, color }) =>
		color === theme.colors.peach
			? `url(${logos_bg_pink})`
			: color === theme.colors.toasted
			? `url(${logos_bg_brown})`
			: color === theme.colors.marmelade
			? `url(${logos_bg_orange})`
			: `url(${logos_bg_purple})`};
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	@media (min-width: 1140px) {
		height: 300px;
	}
	@media (min-width: 1920px) {
		height: 390px;
	}
`;

export const ScFooterAddress = styled.p`
	color: ${({ theme }) => theme.colors.darkText};
	font: ${({ theme }) => theme.fonts.footer.address};
`;

export const ScFooterTitle = styled.p`
	color: ${({ theme }) => theme.colors.darkText};
	font: ${({ theme }) => theme.fonts.footer.title};
	cursor: pointer;
	width: fit-content;
	&:hover {
		text-decoration: underline;
	}
	a {
		color: ${({ theme }) => theme.colors.darkText};
	}
`;

export const ScFooterLink = styled.p`
	color: ${({ theme }) => theme.colors.darkText};
	font: ${({ theme }) => theme.fonts.footer.link};
	cursor: pointer;
	width: fit-content;
	text-decoration: none;
	&:hover {
		text-decoration: underline;
	}
`;

export const ScMobileFooterWrapper = styled.div`
	padding: 35px 20px 6px 20px;
	display: flex;
	flex-direction: column;
	gap: 35px;
`;

export const ScMobileFooterGroups = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
`;

export const ScMobileFooterInfo = styled.div`
	display: grid;
	grid-template-columns: 4fr 1fr;
	column-gap: 55px;
	row-gap: 50px;
	.info {
		font: ${({ theme }) => theme.fonts.footer.addressSmall};
	}
	.right {
		text-align: end;
	}
`;

export const ScMobileFooterText = styled.p`
	color: ${({ theme }) => theme.colors.darkText};
	font: ${({ theme }) => theme.fonts.footer.smallText};
	text-decoration: none;
	b {
		font-family: GeomanistMedium;
	}
	a {
		color: ${({ theme }) => theme.colors.darkText};
		font: ${({ theme }) => theme.fonts.footer.smallLinkText};
		text-decoration: none;
	}
`;

export const ScMobileFooterTitle = styled.p`
	color: ${({ theme }) => theme.colors.darkText};
	font: ${({ theme }) => theme.fonts.footer.mobileLink};
	width: fit-content;
	&.clickable-footer-link {
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
`;
